interface OIDCConfig {
    clientId: string;
    issuer: string;
    redirectUri: string;
    scopes: string[];
}

const config: { oidc: OIDCConfig } = {
    oidc: {
        clientId: import.meta.env.VITE_CLIENT_ID || "",
        issuer: import.meta.env.VITE_ISSUER || "",
        redirectUri: window.location.origin + "/login/callback",
        scopes: ["openid", "profile", "email", "offline_access"]
    }
};
// console.log("OIDC Config:", config);
export default config;
